import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface Props {
  onClick?: () => void;
  value: any;
  className?: string;
}

export default class Radio extends React.Component<any> {

 	// private handleChange = (event: React.ChangeEvent<HTMLInputElement>,name) => {
  //     console.log(event.target.value)
  //     this.setState({
  //       name:event.target.value
  //     })
  // 	} 

	public render() {
    	const { opt, value, name, className, onClick } = this.props;
    	return (
    		<div className={cx(styles.radio, className)}>
          {opt.map((option, index) => {
            return (
              <div className={cx(
                styles.option,
                option.ind == value && styles.selected
              )}
                onClick={onClick.bind(null,name,option.ind)}
                key={index}
              >
                <div className={styles.radioCir}></div>
                <div className={styles.radioTxt}>{option.text}</div>
              </div>
            )
          })}
        </div>
    	)
  }
}
